import Text from "components/text";
import React from "react";
import styles from "./ownData.module.css";

const OwnnYourData = ({
  icon = "",
  hasColor = false,
  title = "",
  body = "",
}) => {
  return (
    <div className={`d-flex flex-column align-items-start`}>
      {icon && <img src={icon} alt={icon} />}
      <div className={`d-flex align-items-center mt-2`}>
        {hasColor && <div className={`${styles.coloredBlock}`}></div>}
        <Text
          className={`${styles.header} ${hasColor ? "mx-2" : ""}`}
          dontWrap={false}
        >
          {title}
        </Text>
      </div>
      <Text className={`${styles.body} mt-2`} dontWrap={false}>
        {body}
      </Text>
    </div>
  );
};

export default OwnnYourData;
